export default "__VITE_ASSET__Bqsv9SQS__"